// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1Cw2K","resendInfoText":"OnGoingPaymentBox_resendInfoText__14Qsc"};